<div class="app-page">
  <div class="row g-3">

    <!-- LEFT: Menu -->
    <div class="col-lg-2">
      <div class="app-card h-100">
        <div class="card-header"><span class="card-title"><i class="bi bi-grid me-2"></i>Menu</span></div>
        <div class="card-body p-0">
          @for (item of filteredMenuItems; track item.type) {
            <div class="d-flex justify-content-between align-items-center px-3 py-2 cursor-pointer border-bottom menu-item-row"
              (click)="goTo(item.type)"
              [class.bg-primary]="ACTIVE_MENU_TYPE === item.type"
              [style.color]="ACTIVE_MENU_TYPE === item.type ? '#fff' : 'inherit'">
              <div class="d-flex align-items-center gap-2">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span class="fs-7 fw-500">{{ item.label }}</span>
              </div>
              <i class="bi bi-chevron-right fs-8"></i>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- RIGHT: Quick nav cards / Dashboard Overview -->
    <div class="col-lg-10">
      @if (ACTIVE_MENU_TYPE === menuTypes.DASHBOARD) {
        <app-dashboard-overview></app-dashboard-overview>
      } @else {
        <div class="app-card mb-3">
          <div class="card-header">
            <span class="card-title"><i class="bi bi-lightning me-2"></i>{{ ACTIVE_MENU_TYPE }}</span>
          </div>
          <div class="card-body">
            <div class="row g-3">
              @for (card of activeCards; track card.label) {
                <div class="col-6 col-sm-4 col-md-3 col-lg-2">
                  <div class="text-center rounded-2 cursor-pointer py-3 h-100 d-flex flex-column align-items-center justify-content-center border hover-shadow"
                    [ngClass]="card.bgColorClass"
                    (click)="card.action()">
                    <img [src]="card.iconPath" [alt]="card.label" width="40" height="40" class="mb-2">
                    <span class="fw-500 fs-7 text-decoration-none" [ngClass]="card.textColorClass">{{ card.label }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>

  </div>
</div>
